/**
 * Lightweight language detection utilities.
 *
 * Extracted from user.js so that modules like currency.js can resolve
 * the current language WITHOUT pulling in Firebase Auth / the entire
 * user module.
 */
import { getObj } from './localStorage';

const SUPPORTED_LANGUAGES = ['en', 'nl', 'de', 'fr', 'es'];

const NON_EN_LANGS = SUPPORTED_LANGUAGES.filter((l) => l !== 'en');

const getLanguageCodeFromSubdomain = () => {
  const hostname = window.location.hostname;

  // klikkie.com: handles www.klikkie.com, {lang}.klikkie.com, dev.klikkie.com,
  // and dev.{lang}.klikkie.com. Any label matching a non-EN lang wins; else EN.
  if (hostname.endsWith('.klikkie.com') || hostname === 'klikkie.com') {
    const subdomain = hostname.replace(/\.?klikkie\.com$/, '');
    const lang = subdomain.split('.').find((label) => NON_EN_LANGS.includes(label));
    return lang || 'en';
  }

  // Firebase hosting: klikkie-website-{dev|prod}-{lang}.web.app (default = EN)
  if (hostname.endsWith('.web.app')) {
    const match = hostname.match(/^klikkie-website-(?:dev|prod)-(nl|de|fr|es)\./);
    return match ? match[1] : 'en';
  }

  // Localhost: detect language from URL path prefix (e.g. /de/subscriptions)
  const pathMatch = window.location.pathname.match(/^\/(de|nl|fr|es)\//);
  return pathMatch ? pathMatch[1] : 'en';
};

export const getUserLanguage = () => {
  return getLanguageCodeFromSubdomain() || getObj('user')?.profile?.languageCode || 'en';
};
